export default "__VITE_ASSET__Ctm9ACBQ__"